import React from "react";
import PropTypes from "prop-types";
import { COLORS, DURATION } from "utils/styles";
import { PROGRESS_BAR_HEIGHT } from "utils/constants/ui";

const DEFAULT_CLASSES = {
  container: "w-100 relative z-3",
  bar: "progressBar absolute h-100 br1"
};

const DEFAULT_STYLES = {
  progressBarColor: COLORS.blue,
  backgroundColor: COLORS.black_10
};

const ProgressBar = ({ progress, customStyles, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const compStyles = { ...DEFAULT_STYLES, ...customStyles };
  const progressStyles = {
    width: `${progress}%`,
    backgroundColor: compStyles.progressBarColor
  };

  return (
    <div
      style={{
        height: `${PROGRESS_BAR_HEIGHT}px`,
        backgroundColor: compStyles.backgroundColor
      }}
      className={classes.container}
    >
      <div className={classes.bar} style={progressStyles}>
        <style jsx>
          {`
            .progressBar {
              -webkit-transition: width ${DURATION}s,
                -webkit-transform ${DURATION}s;
              transition: width ${DURATION}s, transform ${DURATION}s;
            }
          `}
        </style>
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  customClasses: PropTypes.shape({
    container: PropTypes.string,
    bar: PropTypes.string
  }),
  customStyles: PropTypes.shape({
    backgroundColor: PropTypes.string
  })
};

export default ProgressBar;
